import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import callMetricsReducer from './callMetricsSlice';
import filterReducer from './filterSlice';
import screenReducer from "./screenSlice";
import sidebarReducer from "./sidebarSlice";
import leadManagementReducer from './leadManagementPropsSlice';
import customReportsReducer from './customReportsPropsSlice';
import leadManagementDashboardReducer from './leadManagementDashboardSclice';
import studentDetailsViewReducer from './studentDetailsViewSlice';
import pippelineRefreshReducer from "./pipelineRefresh";

// Redux store configuration
const persistConfig = {
  key: "root",
  storage,
};

const persistedScreenReducer = persistReducer(persistConfig, screenReducer);
const persistedSidebarReducer = persistReducer(persistConfig, sidebarReducer);
const persistedLeadManagementReducer = persistReducer(persistConfig, leadManagementReducer);
const persistedCustomReportsReducer = persistReducer(persistConfig, customReportsReducer);
const persistedLeadManagementDashboardReducer = persistReducer(persistConfig, leadManagementDashboardReducer);
const persistedStudentDetailsViewReducer = persistReducer(persistConfig, studentDetailsViewReducer);

export const store = configureStore({
  reducer: {
    callMetrics: callMetricsReducer,
    filter: filterReducer,
    screen: persistedScreenReducer,
    sidebar: persistedSidebarReducer,
    leadManagementProps: persistedLeadManagementReducer,
    customReportsProps: persistedCustomReportsReducer,
    leadManagementDashboard: persistedLeadManagementDashboardReducer,
    studentDetailsView: persistedStudentDetailsViewReducer,
    pipelineRefresh: pippelineRefreshReducer,
  },
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;